import zoho from './zoho.apiCalls';

export default client => ({
  ...zoho(client)
});
